// extracted by mini-css-extract-plugin
export var carrierNotice = "_lc-5";
export var carrierNoticePlaceholder = "_lc-6";
export var deliveryRow = "_lc-c";
export var fixedHeight = "_lc-4";
export var freightLogo = "_lc-b";
export var fullWidth = "_lc-3";
export var priceColumn = "_lc-7";
export var radioSelected = "_lc-9";
export var radioUnselected = "_lc-8";
export var selectedOption = "_lc-2";
export var selectedOptionContainer = "_lc-1";
export var selection = "_lc-0";
export var tallSkeletonText = "_lc-a";